import {webSocket} from "rxjs/observable/dom/webSocket";


export class Impression2 {

  printer: any;
  printJob: any;
  printerIp: string = '192.168.1.170';
  printerPort: number = 9100;
  socket: WebSocket;

  constructor() {

    this.initSocket();
  }

  async initSocket() {

    let url = 'ws//' + this.printerIp + ':' + this.printerPort;
    this.socket = new WebSocket(url);
    //this.socket = new (<any>window).Socket();


  }


  print() {

    let zpl = '^XA^FX Seccion^FO15,20^APN,50,50^FDPechuga Empanada ^FS^FO15,70^APN,50,50^FDy Embolsada^FS^FO15,124^AQN,10,10^FDProducciones^FS^FO15,180^AQN,10,10^FDMIN^FS^FO140,180^AQN,10,10^FDMAX^FS^FO15,205^AQN,50,50^FD-^FS^FO140,205^AQN,50,50^FD-^FS^FO250,205^AQN,50,50^FDKG^FS^FX seccion de codigo de barras^BY3,5,40^FO350,125^BQ,70,4^FDQA,P0000914^FS^XZ';
    this.socket.send(zpl);
  }
}



// WEBPACK FOOTER //
// ./src/classes/inpresion2.ts